import DOMPurify from 'dompurify';

interface JsonObject {
  [key: string]: any;
}

function stripHrefsFromHtml(html: string): string {
  // Configure DOMPurify
  const config = {
    FORBID_ATTR: ['href'], // Allow all attributes except href
  };

  // Use DOMPurify to sanitize and remove href attributes
  const cleanHtml = DOMPurify.sanitize(html, config);
  return cleanHtml;
}

function nullHrefsInJsonHTMLTraverse(obj: Record<string, any>): void {
  for (const key in obj) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      nullHrefsInJsonHTMLTraverse(obj[key]);
    } else if (key === 'textContent' && typeof obj[key] === 'string') {
      obj[key] = stripHrefsFromHtml(obj[key]);
    }
  }
}

export function nullHrefsInJsonHTML(
  objectToInspect: Record<string, any>
): JsonObject {
  nullHrefsInJsonHTMLTraverse(objectToInspect);
  return objectToInspect;
}

// function updateHrefs(
//   firstHtml: string,
//   secondHtml: string | undefined
// ): string {
//   // Sanitize both inputs
//   const cleanFirstHtml = DOMPurify.sanitize(firstHtml);

//   // Parse the sanitized HTML
//   const parser = new DOMParser();
//   const firstDoc = parser.parseFromString(cleanFirstHtml, 'text/html');
//   const secondDoc = secondHtml
//     ? parser.parseFromString(secondHtml, 'text/html')
//     : null;

//   // Update hrefs
//   const firstAnchors = firstDoc.getElementsByTagName('a');
//   const secondAnchors = secondDoc ? secondDoc.getElementsByTagName('a') : [];

//   for (let i = 0; i < firstAnchors.length; i++) {
//     if (i < secondAnchors.length) {
//       const newHref = secondAnchors[i].getAttribute('href');
//       if (newHref) {
//         firstAnchors[i].setAttribute('href', newHref);
//       } else {
//         firstAnchors[i].removeAttribute('href');
//       }
//     } else {
//       firstAnchors[i].removeAttribute('href');
//     }
//   }

//   // Serialize the updated HTML
//   return new XMLSerializer()
//     .serializeToString(firstDoc.body)
//     .replace(/<\/?body>/g, '');
// }

// TODO An interesting idea is to replace each href with a unique id, and then
// convert back when we get the document back. No comparing necessary. We can
// even tell the AI that it is not allowed to update or create new links. Null
// out any that we don't recognize.
// export function copyOrNullHrefsInJsonHtml(
//   firstJson: JsonObject,
//   secondJson: JsonObject
// ): JsonObject {
//   function traverse(first: JsonObject, second?: JsonObject): void {
//     for (const key in first) {
//       if (typeof first[key] === 'object' && first[key] !== null) {
//         if (second?.[key] && typeof second[key] === 'object') {
//           traverse(first[key], second[key]);
//         } else {
//           traverse(first[key]);
//         }
//       } else if (key === 'textContent' && typeof first[key] === 'string') {
//         if (second) {
//           first[key] = updateHrefs(first[key], second[key]);
//         } else {
//           first[key] = stripHrefsFromHtml(first[key]);
//         }
//       }
//     }
//   }

//   const result = JSON.parse(JSON.stringify(firstJson));
//   traverse(result, secondJson);
//   return result;
// }
